export default async function ({ app, redirect, route, query, $auth }) {
  const lp = route.query.lp

  if (
    (route.name === 'app-account-activate' && !query?.token) ||
    (route.name === 'app-account-forgotPassword' && !query?.token)
  ) {
    return redirect(app.$link.login())
  }

  const isProjectPage = route?.name === 'app-project-id'

  if (isProjectPage && route?.params?.id && query?.token) {
    await $auth.$storage.setUniversal('projectId', route.params.id, true)
  }

  if (route.name !== 'app-account-activate' && !$auth.loggedIn) {
    if (query?.token) {
      try {
        const { data: getToken } = await app.$api.login.authorizeWithUrlToken({
          urlToken: query.token,
          actorDeviceUUID: app.$trustedToken()
        })
        await $auth.setUserToken(getToken.access_token, getToken.refresh_token)
      } catch (err) {
        const statusCode = err?.response?.status || 500

        // If unauthorized or token expired
        if (statusCode === 401 || statusCode === 403) {
          return redirect(app.$link.login())
        }

        // If this was a project page, try fallback
        if (isProjectPage && route?.params?.id) {
          try {
            const { data: projectData } = await app.$api.project.getProject(route.params.id)
            await $auth.$storage.setUniversal('projectData', projectData, true)
            await $auth.$storage.removeUniversal('projectId')
            return redirect(app.$link.project(projectData))
          } catch (e) {
            console.error('Failed to fallback load project', e)
            return app.context.error({
              statusCode: e?.response?.status || 500,
              message: 'Unable to load project'
            })
          }
        }

        // Default error fallback
        return app.context.error({
          statusCode,
          message: 'An unexpected error occurred while trying to authorize with URL token'
        })
      }
    } else {
      try {
        const payload = {
          tokenUuid: lp,
          deviceUuid: app.$trustedToken()
        }
        const { data: responseOfLeadProfileToken } =
          await app.$api.freelancer.authorizeWithLeadProfileToken(payload)

        await $auth.setUserToken(
          responseOfLeadProfileToken.access_token,
          responseOfLeadProfileToken.refresh_token
        )

        if (responseOfLeadProfileToken.didAutoActivation) {
          app.store.commit('modal/SHOW_LEAD_PROFILE_MODAL')
        }
      } catch (err) {
        console.error('Error in check-lp middleware', err.response?.data || err.message)
      }
    }
  }
}
